import React, { useEffect } from 'react';
import styled from 'styled-components';

import { Title } from 'components';
import Swal from 'sweetalert2';
import { SupraLogo } from 'components/SideMenu/StyledComponents';
import { featureEnabled } from 'utils';

const Error403TeamAccountPage: React.FC = () => {
  const REcoTeamIdErrorSwal = () => {
    Swal.fire({
      type: 'warning',
      title: 'You cannot book a showing under a Team Id.',
      html: `
        <div>
          We are unable to authenticate your MLS membership or state license
          when logged in under a Team ID. Please log in under your personal
          account to schedule a showing, or call the listing brokerage to book a
          showing.
        </div>`,
    });
  };

  useEffect(() => {
    REcoTeamIdErrorSwal();
  }, []);

  return (
    <Container>
      <Header>
        {featureEnabled('supraRebrandingFeature', 1) ? (
          <SupraLogo />
        ) : (
          <StyledImg src="/img/logo_v2.svg" />
        )}
      </Header>
      <Main>
        <Title>403 - Forbidden</Title>
        <Title level={2}>
          This listing may not exist anymore, or you do not have permission to
          view the listing.
        </Title>
      </Main>
    </Container>
  );
};

export default Error403TeamAccountPage;

const Container = styled.div``;

const Header = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 25px;
`;
const Main = styled.div`
  padding: 25px;
`;
const StyledImg = styled.img`
  width: 555px;
`;
